"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.name = exports["default"] = exports.availableProps = void 0;
var _react = _interopRequireDefault(require("react"));
var _selectors = require("../Theme/selectors");
var _template = _interopRequireDefault(require("./template"));
var _excluded = ["colorOne", "colorTwo"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var Substitution = function Substitution(_ref) {
  var colorOne = _ref.colorOne,
    colorTwo = _ref.colorTwo,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_template["default"], _extends({}, otherProps, {
    renderPaths: function renderPaths(uiTheme) {
      var style = {
        one: {},
        two: {}
      };
      if (colorOne) {
        style.one.fill = (0, _selectors.getColor)(uiTheme, colorOne);
      }
      if (colorTwo) {
        style.two.fill = (0, _selectors.getColor)(uiTheme, colorTwo);
      }
      return /*#__PURE__*/_react["default"].createElement("g", {
        transform: "translate(4.000000, 7.000000)"
      }, /*#__PURE__*/_react["default"].createElement("path", {
        style: style.one,
        d: "M25.3333333,5.11136176 C19.1106667,-0.95573824 9.33333333,2.72716176 9.33333333,10.3646618 L13.3333333,10.3646618 L6.66666667,18.1646618 L0,10.3646618 L4,10.3646618 C5.5,-0.0080382402 19.4586667,-4.07053824 25.3333333,5.11136176 Z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        style: style.two,
        d: "M6.66666667,20.6905618 C12.8893333,26.7576618 22.6666667,23.0734618 22.6666667,15.4359618 L18.6666667,15.4359618 L25.3333333,7.63596176 L32,15.4359618 L28,15.4359618 C26.5,25.8099618 12.5413333,29.8711618 6.66666667,20.6905618 Z"
      }));
    }
  }));
};
Substitution.defaultProps = {
  colorOne: null,
  colorTwo: null
};
var _default = exports["default"] = Substitution;
var name = exports.name = 'Substitution';
var availableProps = exports.availableProps = ['colorOne', 'colorTwo'];